import React from 'react';
import { CategoryHeroConfig } from '../CategoryConfigProvider';
import IntentSelect from '../GetStartedInteractive/StepComponent/steps/IntentSelect';
import HeroHeadingText from '../GetStartedInteractive/InteractiveHeader/HeroHeadingText';
import Grid from '../../Grid';
import Box from '../../../../shared/spa/core-components/Box';

interface Props {
    categoryKey: string;
    hero: CategoryHeroConfig;
}

export function HeroHeading({ categoryKey, hero }: Props) {
    return (
        <>
            <Grid>
                <Box paddingTop={['space10', 'space16']}>
                    <HeroHeadingText
                        title={hero.title}
                        titlePrefix={hero.titlePrefix}
                        description={hero.description}
                        headingGradient={hero.headingGradient}
                    />
                </Box>
            </Grid>

            <IntentSelect
                heroInteraction={hero.interaction}
                categoryKey={categoryKey}
                hasAnimation={true}
            />
        </>
    );
}
